import { useState } from 'react'
import { useSelector } from 'react-redux'

import ButtonShowMore from '../ButtonShowMore/ButtonShowMore.js'
import Carousel from '../Carousel/Carousel.js'
import ContainerSeries from '../Container/ContainerSeries.js'
import Footer from '../Footer/Footer.js'
import ModalCard from '../ModalCard/ModalCard.js'
import SearchOptions from '../SearchsOptions/SearchOptions.js'
import Whatsapp from '../Whatsapp/Whatsapp.js'

const Series = () => {

    const [categories, setCategories] = useState(null)
    const [searchBarValue, setSearchBarValue] = useState(null)
    const showButton = useSelector(state => state.containerSeries.showButton)
    const showModalCard = useSelector(state => state.modalCard.show)

    const handleClick = (input, categories) => {
        setSearchBarValue(input)
        setCategories(categories)
    }

    return (
        <div className='fl-cl series__container'>
            <Carousel type="series" />
            <SearchOptions onClick={handleClick} placeholder='Escribe el nombre de una serie' />
            <ContainerSeries categories={categories} input={searchBarValue} />
            {
                showModalCard
                    ? <ModalCard />
                    : undefined

            }
            {
                showButton
                    ? <ButtonShowMore series={true} />
                    : undefined
            }
            <Whatsapp />
            <Footer />
        </div>
    )
}

export default Series